<figure>
  <div class="wrapper promo-content">
    <p class="dsd-t-5 dsd-fw-normal intro">
      {{ 'dashboard.promo.intro-1' | translate }}
      <span class="dsd-c-light-primary-4 dsd-fw-bold">+</span>
      <span [innerHTML]="'dashboard.promo.intro-2' | translate"></span>
    </p>
    <p class="dsd-t-3">
      <span class="sm:dsd-d-inline offre">{{ 'dashboard.promo.offre-1' | translate }}</span>
      <app-currency-string [value]="1500" class="dsd-t-1 sm:dsd-d-inline dsd-mb-0"></app-currency-string>
      <span class="dsd-d-inline offre">
        {{ 'dashboard.promo.offre-2' | translate }}
      </span>
      <app-currency-string [value]="4000" class="dsd-t-1 dsd-d-inline dsd-mb-0"></app-currency-string>
      <span class=" dsd-d-inline offre">
        {{ 'dashboard.promo.offre-3' | translate }}
      </span>
    </p>
    <p class="dsd-t-5 dsd-fw-normal offre-bonifie">
      <span class="dsd-d-inline offre-bonifie">{{ 'dashboard.promo.offre-bonifie-1' | translate }}</span>
      <span class="dsd-d-inline offre-bonifie dsd-fw-bold">
        {{ 'dashboard.promo.offre-bonifie-2' | translate }}
      </span>
      <app-currency-string [value]="500" class="dsd-d-inline dsd-mb-0 dsd-fw-bold"></app-currency-string>
      <span class="dsd-d-inline offre-bonifie dsd-fw-bold">
        {{ 'dashboard.promo.offre-bonifie-3' | translate }}
      </span>
      <span class=" dsd-d-inline offre-bonifie">
        {{ 'dashboard.promo.offre-bonifie-4' | translate }}
      </span>
    </p>
    <p class="dsd-t-5 intro">
      <dsd-link
        id="lien-en-savoir-plus"
        [href]="promoUrl"
        (click)="pushCybermetrie()"
        [label]="'dashboard.promo.lien-externe' | translate"
      >
        {{ 'dashboard.promo.en-savoir-plus' | translate }}
      </dsd-link>
    </p>
  </div>
</figure>
